import { api } from "./api";

/**
 * Get all unique expert networks from the expert_networks table
 */
export const getExpertNetworks = async (): Promise<string[]> => {
  try {
    const response = await api.get("/api/expert-networks");
    return response.data.map((network: any) => network.name).sort();
  } catch (error) {
    console.error("Error fetching expert networks:", error);
    return [];
  }
};

/**
 * Get all unique angles from existing interviews
 */
export const getExistingAngles = async (
  projectId?: string
): Promise<string[]> => {
  try {
    const endpoint = projectId
      ? `/api/interviews?projectId=${projectId}`
      : "/api/interviews";
    const response = await api.get(endpoint);
    const angles = response.data
      .map((interview: any) => interview.angle)
      .filter((angle: string) => angle && angle.trim() !== "")
      .filter(
        (angle: string, index: number, arr: string[]) =>
          arr.indexOf(angle) === index // Remove duplicates
      )
      .sort();

    return angles;
  } catch (error) {
    console.error("Error fetching existing angles:", error);
    return [];
  }
};
